import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import AddButton from './AddButton';
import CancelButton from './CancelButton';
import PrimaryButton from './PrimaryButton';
import { globalStyles as styles } from './style/gstheme';
import TitledTextField from './TitledTextField';
import { MAX_LITERAL_LENGTH } from './utils/constants';
import { checkValidity, sanitiseText } from './utils/utils';

class IRIdialog extends React.Component {

    state = {
        open: false,
        iri: "",
        needsValidating: false,
        existingValues: [],
        error: false,
        existing: false
    };

    // Need to check if an incoming revision causes a duplicate
    static getDerivedStateFromProps(props, state) {
        if (state.iri && state.iri !== "" && props.existingValues && props.existingValues.length > 0) {
            if (props.existingValues.length === state.existingValues.length) {
                const hasChanged = props.existingValues.some(ev => !state.existingValues.includes(ev));
                if (!hasChanged) return null;
            }
            return { needsValidating: true, existingValues: props.existingValues };
        }
        return null;
    }

    componentDidUpdate() {
        if (this.state.needsValidating && this.state.iri && this.state.iri !== "") this.checkValid();
    }

    handleClickOpen = () => this.setState({ open: true });

    addIRI = () => {
        this.setState({ open: false });
        this.props.onAddIRI(this.state.iri);
        this.setState({ iri: "" });
    };

    exitAddIRI = () => this.setState({
        open: false,
        iri: "",
        datatype: "",
        error: false,
        existing: false
    });

    checkValid() {
        const { existingValues, maxLength } = this.props;
        const { iri, originalText } = this.state;
        if (iri.trim() === "" || this.state.iri.trim() === originalText) {
            this.setState({ error: false, existing: false, needsValidating: false });
            return;
        }
        let validity = checkValidity(iri.trim(), "http://www.w3.org/2001/XMLSchema#anyURI", existingValues, maxLength);
        try {
            // If invalid for whatever reason return false (might be partially escaped char for instance)
            // Change this to use basicCheckIRI
            decodeURI(iri);
            const url = new URL(iri);
            if (url.hash && url.hash.substring(1).includes('#')) validity = false;
            if (url.hash.includes('"')) validity = false;
        }
        catch (e) {
            validity = false;
        }
        this.setState({ error: !validity.isValid, existing: validity.existing, needsValidating: false });
    }

    handleChange = (event) => {
        const t = event.target;
        const cleanText = sanitiseText(t.value.trimLeft());
        this.setState({ [t.name]: cleanText }, this.checkValid);
    };

    render() {

        const { iri, error, existing } = this.state;
        const { classes, title, name, placeholder, dataTest } = this.props;

        return (
            <React.Fragment>
                <AddButton dataTest={dataTest + "-add"} title="Add IRI" onClick={this.handleClickOpen} />
                <Dialog
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paperWidthMd: classes.mediumDialog
                    }}
                    open={this.state.open}
                    onClose={this.exitAddLiteral}
                    aria-labelledby="createIRI-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="createlIRI-dialog-title">{title}</DialogTitle>
                    <DialogContent style={{ height: '130px' }}>
                        <form autoComplete="off" noValidate="novalidate">
                            <TitledTextField
                                dataTest="datatype"
                                name="iri"
                                title={name || "IRI"}
                                autoFocus={true}
                                required={true}
                                placeholder={placeholder}
                                error={error || existing}
                                text={iri}
                                errorText={
                                    existing ?
                                        "This value already exists."
                                        :
                                        (error ?
                                            "The value is not a valid IRI."
                                            :
                                            null
                                        )
                                }
                                maxLength={MAX_LITERAL_LENGTH}
                                onEnter={this.addIRI}
                                onChange={this.handleChange} />
                        </form>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitAddIRI} />
                        <PrimaryButton dataTest="add-datatype" disabled={iri.trim().length === 0 || error || existing} onClick={this.addIRI}>Add</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}


IRIdialog.propTypes = {
    dataTest: PropTypes.string,
    name: PropTypes.string.isRequired,
    existingValues: PropTypes.array,
    placeholder: PropTypes.string,
    title: PropTypes.string.isRequired,
    textRef: PropTypes.string,
    onAddIRI: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(IRIdialog);
